export const pushEvent = (eventName: string, metadata?: Record<string, unknown>): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    const timeout = setTimeout(resolve, 500);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).dataLayer = (window as any).dataLayer || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload: any = {
      event: eventName,
      eventCallback: () => {
        clearTimeout(timeout);
        resolve();
      },
    };
    if (metadata) {
      payload.metadata = metadata;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).dataLayer.push(payload);
  });
};
